export default __webpack_public_path__ + "static/media/Drop Cards.7374f320.webp";